// returns what url to show in the notification, or false if no notification should be shown because on different host

export default function parseNotificationUrl(url: string): string | false {
	const urlHost = url
		.replace("http://", "")
		.replace("https://", "")
		.split("/")[0]
		.replace("www.", "")
	const currentHost = window.location.host.replace("www.", "")

	if (urlHost !== currentHost) return false

	let urlPath = url
		.replace("http://", "")
		.replace("https://", "")
		.slice(url.replace("http://", "").replace("https://", "").indexOf("/"))
	if (urlPath.endsWith("/")) urlPath = urlPath.substring(0, urlPath.length - 1)
	if (urlHost === currentHost && urlPath.length > 0) return urlPath
	let urlWithNoTrailingSlash = url.endsWith("/")
		? url.substring(0, url.length - 1)
		: url
	return urlWithNoTrailingSlash.replace("http://", "").replace("https://", "")
}
